/**
 * After Cash App is used, the Stripe SDK will be stuck in a processing state.
 * This completes the transaction internally in the Stripe SDK after the redirect.
 * If this does not occur, the app will crash on the next usage of Cash App.
 * Note: iOS only.
 */
export const useStripeDeepLink = () => {};
